import * as $ from "jquery";
import tracking from '../../utils/tracking';
import storage from "../../utils/storage";

export default class CloudGrowthTracker {
  VERSION = 'prd';

  sendTrackVisitCounter(cookieName: string) {
    let visitCounter = storage.getCookie(cookieName) || 0;

    if (visitCounter) {
      visitCounter = parseInt(visitCounter, 10);
    }

    if (visitCounter < 0) {
      visitCounter = 0;
    }

    visitCounter++;
    storage.setCookie(cookieName, visitCounter);

    this.sendTrack('signupPageVisitCount', { visitCount: visitCounter} );
  }

  sendTrackSubmitCounter(cookieName: string) {
    let submitCounter = storage.getCookie(cookieName) || 0;

    if (submitCounter) {
      submitCounter = parseInt(submitCounter, 10);
    }

    if (submitCounter < 0) {
      submitCounter = 0;
    }

    submitCounter++;
    storage.setCookie(cookieName, submitCounter);

    this.sendTrack('repeat_submit', { 'submitCount': submitCounter});
  }

  sendTrackSubmitSuccess(cookieName: string) {

    let counter = storage.getCookie(cookieName) || 0;

    if (counter) {
      counter = parseInt(counter, 10);
    }

    if (counter < 0) {
      counter = 0;
    }

    counter++;
    storage.setCookie(cookieName, counter);

    this.sendTrack('form_submit_signup_success', { 'submitCount': counter});
  }

  sendTrack(eventName: string, props: any) {
    // standardize event name
    const standardEventName = `grow.expevt.prd.${eventName}`;

    this.sendToGAS(standardEventName, props);
    this.sendToSegmentJS(standardEventName, props);
  }

  sendToSegmentJS(e_name: string, props: any) {
    let data = {
      'eventAction': e_name,
      'product': 'wac',
      'page_path': window.location.pathname,
      'page_url': window.location.href,
      'referrer': document.referrer,
      'version': this.VERSION
    };

    if (props) {
      Object.assign(data, props);
    }

    try {
      tracking.trackEvent(e_name, data);
    } catch(e) {
      this.sendToGAS(`ERR: ${e.toString()}` );
    }
  }

  sendToSegmentHTTP(e_name: string, props: any) {
    const anonId = decodeURIComponent(storage.getCookie('ajs_user_id')).replace(/"/g, '');

    let data = {
      'anonymousId': anonId,
      'event': e_name,
      'timestamp': new Date(),
      'writeKey': 'kiv6wyh2nw',
      'properties': {
        'product': 'wac',
        'page_path': window.location.pathname,
        'page_url': window.location.href,
        'referrer': document.referrer,
        'version': this.VERSION
      }
    };

    if (props) {
      Object.assign(data.properties, props);
    }

    $.ajax({
      type: 'POST',
      url: 'https://api.segment.io/v1/track',
      data: JSON.stringify(data),
      contentType: 'application/json'
    })
    .fail( () => {
      this.sendToGAS('segmentHTTP_fail');
    });
  }

  sendToGAS() {
    // Noop - GasV2 events are deprecated; 'https://analytics.atlassian.com/analytics/event' endpoint throws 422.
  }
}
